<div fxLayout="column" class="layout-padd scrolled" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <div fxLayoutAlign="center center" class="layout-padd">
        <img style="height: 120px;" [ngStyle.xs]="{'height' : '100px'}"
            src="assets/img/dialogs/test-checkdelivery-1.png">
    </div>
    <div fxLayout="column" *ngIf="error_elligible_city" fxLayoutAlign="center center">
        <div class=" warn-ico">{{'checkAdressComponent.noEligibityCity' | translate}} </div>
        <div class="layout-padd">
            <button mat-stroked-button class="dark-ico" (click)="dialogRef.close()" fxFlex>{{"dialogs.go-back" | translate}}</button>
        </div>
    </div>

    <div class="full-w" *ngIf="!loaders.countries && countries">
        <form [formGroup]="checkCityForm" #formDirective="ngForm" fxLayout="column" class="layout-padd">
            <div fxLayout="row" fxLayoutGap="10px" fxLayout.xs="column">

                <!-- Country -->
                <div class="form-field-endorder" fxFlex *ngIf="!loaders.countries && countries && countries.length>1">

                    <mat-form-field appearance="outline" class="full-w">
                        <mat-label>{{'checkAdressComponent.country' | translate}}</mat-label>



                        <mat-select formControlName="country" (openedChange)="selectedDataValue($event)">



                            <mat-option *ngFor="let country of countries" [value]="country.id_country"
                                (click)="setSelectedCountry(country)">
                                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

                                    <!-- <img src="data:image/png;base64,{{country.flag}}" height="25"> -->
                                    <img *ngIf="country.flag" src="data:image/png;base64,{{country.flag}}"  class="h-8">
                                    <div *ngIf="!country.flag">
                                        <mat-icon>outlined_flag</mat-icon>
                                    </div>
                                    <span>{{country.name | uppercase}}</span>
                                </div>
                            </mat-option>

                        </mat-select>
                    </mat-form-field>

                </div>



            </div>




            <div fxLayout="row" fxLayoutAlign="center center" class="layout-padd text-center">
                <span class="mat-title" ngClass.xs="mat-subheading-1">{{'checkAdressComponent.eligibityCityCheck' | translate}} </span>
            </div>




            <!-- <form [formGroup]="checkCityForm" #formDirective="ngForm" fxLayout="column" class="layout-padd"> -->

            <mat-form-field>

                <mat-label>{{'checkAdressComponent.postalCode' | translate}} </mat-label>

                <input matInput autocomplete="none|false|no" placeholder="Code postal" formControlName="postal"
                    #autoCompletePostal (keydown.backspace)="removePostal()">

                <mat-icon matSuffix class="clicked dark-ico" (click)="dialogMan.openEligibleCitiesDial()"
                    matTooltip="{{'basket.eligible-cities-list'|translate}}">not_listed_location</mat-icon>

                <mat-hint class="mat-caption" *ngIf="unavailablePostal && checkCityForm.get('postal').value">
                    {{'checkAdressComponent.nogoodCode' | translate}}</mat-hint>

                <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('postal')">
                    <span class="mat-caption"> {{'checkAdressComponent.postalCoderequired' | translate}}</span>
                </mat-error>

            </mat-form-field>

            <div fxLayoutAlign="center center">
                <mat-spinner diameter="20" *ngIf="loaders.postals"></mat-spinner>
            </div>

            <mat-form-field *ngIf="filteredCities">

                <mat-label>{{'checkAdressComponent.city' | translate}} </mat-label>

                <mat-select placeholder="{{'checkAdressComponent.city' | translate}}" formControlName="city" #selectCities>

                    <mat-option *ngFor="let city of filteredCities" [value]="city.id" (click)="checkCityOnChange()">
                        {{city.name}} {{city.Ligne_5 ? "(" + city.Ligne_5 + ")" : ""}}
                    </mat-option>

                </mat-select>

                <mat-spinner diameter="20" *ngIf="loaders.cities"></mat-spinner>

                <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('city')">
                    <span class="mat-caption">{{'checkAdressComponent.cityrequired' | translate}}</span>
                </mat-error>

            </mat-form-field>

        </form>

        <div class="layout-padd">

            <!-- Eligible -->
            <div fxLayout="column" *ngIf="checkCityForm.get('city').value && checkValid && !loaders.eligible"
                class="layout-padd great border-check rad-bord" fxLayoutGap="5px">

                <div fxLayoutAlign="center center">
                    <i class="fas fa-check-circle check-ico" ngClass.xs="check-ico-xs"></i>
                </div>

                <div>

                    <div class="text-center">
                        <span class="mat-subheading-1">{{'checkAdressComponent.eligiblecityShipping' | translate}}</span>
                    </div>

                    <div class="text-center">
                        <span class="mat-subheading-1">{{'checkAdressComponent.shippingcost' | translate}}
                            <strong>{{currDelivryZone.delivery_price | priceFilter}}</strong></span>
                    </div>

                    <div class="text-center" *ngIf="currDelivryZone.offered_from">
                        <span class="mat-subheading-1">{{'checkAdressComponent.freeShipping' | translate}}
                            <strong>{{currDelivryZone.offered_from | priceFilter}}</strong></span>
                    </div>


                </div>

                <div class="layout-padd" fxLayoutAlign="center center" *ngIf="fromSmDial">

                    <button mat-stroked-button class="dark-ico" (click)="dialogRef.close(true)" angulartics2On="click"
                        angularticsAction="closeDialEligible" angularticsCategory="delivryAddresses"
                        fxFlex>{{"dialogs.continue" | translate}}</button>

                </div>

            </div>

            <!-- Non éligible -->
            <div fxLayout="column" *ngIf="checkCityForm.get('city').value && !checkValid && !loaders.eligible"
                fxLayoutGap="5px" class="layout-padd warn border-check rad-bord">

                <div fxLayoutAlign="center center">
                    <i class="fas fa-times-circle check-ico" ngClass.xs="check-ico-xs"></i>
                </div>

                <div fxLayoutAlign="center center" class="text-center">
                    <span class="mat-subheading-1">{{'checkAdressComponent.noeligiblecityShipping' | translate}} </span>
                </div>

            </div>

            <!-- Chosir ville -->
            <div *ngIf="!checkCityForm.get('city').value && !loaders.eligible" fxLayoutAlign="center center"
                class="layout-padd">
                <span class="mat-subheading-1">{{'checkAdressComponent.chooseCity' | translate}} </span>
            </div>

            <!-- Loader -->
            <div *ngIf="loaders.eligible" fxLayoutAlign="center center" class="layout-padd">
                <mat-spinner diameter="20"></mat-spinner>
            </div>

        </div>

    </div>

    <div class="layout-padd" *ngIf="!loaders.countries && countries">
        <button mat-stroked-button class="dark-ico" (click)="dialogRef.close()" fxFlex>{{"dialogs.go-back" | translate}}</button>
    </div>
    <div *ngIf="loaders.countries && !countries" fxLayoutAlign="center center" class="layout-padd">
        <mat-spinner diameter="80"></mat-spinner>
    </div>
</div>
<!-- <app-popup-loader [flagLoading]="loaders.countries && !countries" [size]="60" [statusMessage]="'Récupération de vos données'">
</app-popup-loader> -->
<!-- Loader-->
